/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Dashboard } from '../models/dashboard';
import { TagWidget } from '../models/tag-widget';
import { PDashboard } from '../models/pdashboard';
@Injectable({
  providedIn: 'root',
})
class DashboardService extends __BaseService {
  static readonly DashboardGetMyDashboardsPath = '/api/Dashboard/GetMyDashboards';
  static readonly DashboardGetCategoriesPath = '/api/Dashboard/GetCategories/{customerId}';
  static readonly DashboardGetRecentDashboardsPath = '/api/Dashboard/GetRecentDashboards';
  static readonly DashboardGetAvailableWidgetsPath = '/api/Dashboard/AvailableWidgets/{tagName}/{tagValue}/{customerId}';
  static readonly DashboardGetAvailableWidgetsForSiteTypePath = '/api/Dashboard/AvailableWidgetsForTimeSeries/{siteType}/{customerId}';
  static readonly DashboardGetCustomerDashboardsPath = '/api/Dashboard/GetCustomerDashboards';
  static readonly DashboardGetPublicationPath = '/api/Dashboard/GetPublication';
  static readonly DashboardGetDashboardPath = '/api/Dashboard/GetDashboardById';
  static readonly DashboardGetPublicDashboardByIdPath = '/api/Dashboard/GetPublicDashboardById';
  static readonly DashboardUpdateDashboardPath = '/api/Dashboard/UpdateDashboard';
  static readonly DashboardUpdateDashboardDetailsPath = '/api/Dashboard/UpdateDashboardDetails';
  static readonly DashboardMakeFavouritePath = '/api/Dashboard/MakeFavourite';
  static readonly DashboardRemoveFavouritePath = '/api/Dashboard/RemoveFavourite';
  static readonly DashboardArchiveDashboardPath = '/api/Dashboard/ArchiveDashboard';
  static readonly DashboardUnArchiveDashboardPath = '/api/Dashboard/UnArchiveDashboard';
  static readonly DashboardPublishToPublicPath = '/api/Dashboard/PublishToPublic';
  static readonly DashboardUnPublishToPublicPath = '/api/Dashboard/UnPublishToPublic';
  static readonly DashboardPublishToGlobalPath = '/api/Dashboard/PublishToGlobal';
  static readonly DashboardUnPublishToGlobalPath = '/api/Dashboard/UnPublishToGlobal';
  static readonly DashboardAddDashboardPath = '/api/Dashboard/AddDashboard';
  static readonly DashboardAddCustomerDashboardPath = '/api/Dashboard/AddCustomerDashboard';
  static readonly DashboardRemoveDashboardPath = '/api/Dashboard/RemoveDashboard';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  DashboardGetMyDashboardsResponse(): __Observable<__StrictHttpResponse<Array<Dashboard>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetMyDashboards`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Dashboard>>;
      })
    );
  }  DashboardGetMyDashboards(): __Observable<Array<Dashboard>> {
    return this.DashboardGetMyDashboardsResponse().pipe(
      __map(_r => _r.body as Array<Dashboard>)
    );
  }

  /**
   * @param customerId undefined
   */
  DashboardGetCategoriesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetCategories/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DashboardGetCategories(customerId: number): __Observable<Array<string>> {
    return this.DashboardGetCategoriesResponse(customerId).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }
  DashboardGetRecentDashboardsResponse(): __Observable<__StrictHttpResponse<Array<Dashboard>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetRecentDashboards`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Dashboard>>;
      })
    );
  }  DashboardGetRecentDashboards(): __Observable<Array<Dashboard>> {
    return this.DashboardGetRecentDashboardsResponse().pipe(
      __map(_r => _r.body as Array<Dashboard>)
    );
  }

  /**
   * @param params The `DashboardService.DashboardGetAvailableWidgetsParams` containing the following parameters:
   *
   * - `tagValue`:
   *
   * - `tagName`:
   *
   * - `customerId`:
   */
  DashboardGetAvailableWidgetsResponse(params: DashboardService.DashboardGetAvailableWidgetsParams): __Observable<__StrictHttpResponse<Array<TagWidget>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/AvailableWidgets/${encodeURIComponent(String(params.tagName))}/${encodeURIComponent(String(params.tagValue))}/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TagWidget>>;
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardGetAvailableWidgetsParams` containing the following parameters:
   *
   * - `tagValue`:
   *
   * - `tagName`:
   *
   * - `customerId`:
   */
  DashboardGetAvailableWidgets(params: DashboardService.DashboardGetAvailableWidgetsParams): __Observable<Array<TagWidget>> {
    return this.DashboardGetAvailableWidgetsResponse(params).pipe(
      __map(_r => _r.body as Array<TagWidget>)
    );
  }

  /**
   * @param params The `DashboardService.DashboardGetAvailableWidgetsForSiteTypeParams` containing the following parameters:
   *
   * - `siteType`:
   *
   * - `customerId`:
   */
  DashboardGetAvailableWidgetsForSiteTypeResponse(params: DashboardService.DashboardGetAvailableWidgetsForSiteTypeParams): __Observable<__StrictHttpResponse<Array<TagWidget>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/AvailableWidgetsForTimeSeries/${encodeURIComponent(String(params.siteType))}/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TagWidget>>;
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardGetAvailableWidgetsForSiteTypeParams` containing the following parameters:
   *
   * - `siteType`:
   *
   * - `customerId`:
   */
  DashboardGetAvailableWidgetsForSiteType(params: DashboardService.DashboardGetAvailableWidgetsForSiteTypeParams): __Observable<Array<TagWidget>> {
    return this.DashboardGetAvailableWidgetsForSiteTypeResponse(params).pipe(
      __map(_r => _r.body as Array<TagWidget>)
    );
  }

  /**
   * @param customerId undefined
   */
  DashboardGetCustomerDashboardsResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<Dashboard>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetCustomerDashboards`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Dashboard>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DashboardGetCustomerDashboards(customerId?: number): __Observable<Array<Dashboard>> {
    return this.DashboardGetCustomerDashboardsResponse(customerId).pipe(
      __map(_r => _r.body as Array<Dashboard>)
    );
  }

  /**
   * @param identifier undefined
   */
  DashboardGetPublicationResponse(identifier?: null | string): __Observable<__StrictHttpResponse<PDashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (identifier != null) __params = __params.set('identifier', identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetPublication`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PDashboard>;
      })
    );
  }
  /**
   * @param identifier undefined
   */
  DashboardGetPublication(identifier?: null | string): __Observable<PDashboard> {
    return this.DashboardGetPublicationResponse(identifier).pipe(
      __map(_r => _r.body as PDashboard)
    );
  }

  /**
   * @param id undefined
   */
  DashboardGetDashboardResponse(id?: number): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetDashboardById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DashboardGetDashboard(id?: number): __Observable<Dashboard> {
    return this.DashboardGetDashboardResponse(id).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param identifier undefined
   */
  DashboardGetPublicDashboardByIdResponse(identifier?: null | string): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (identifier != null) __params = __params.set('identifier', identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Dashboard/GetPublicDashboardById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param identifier undefined
   */
  DashboardGetPublicDashboardById(identifier?: null | string): __Observable<Dashboard> {
    return this.DashboardGetPublicDashboardByIdResponse(identifier).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param dashboard undefined
   */
  DashboardUpdateDashboardResponse(dashboard: Dashboard): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboard;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Dashboard/UpdateDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param dashboard undefined
   */
  DashboardUpdateDashboard(dashboard: Dashboard): __Observable<Dashboard> {
    return this.DashboardUpdateDashboardResponse(dashboard).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param dashboard undefined
   */
  DashboardUpdateDashboardDetailsResponse(dashboard: Dashboard): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboard;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Dashboard/UpdateDashboardDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param dashboard undefined
   */
  DashboardUpdateDashboardDetails(dashboard: Dashboard): __Observable<Dashboard> {
    return this.DashboardUpdateDashboardDetailsResponse(dashboard).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param dashboardId undefined
   */
  DashboardMakeFavouriteResponse(dashboardId?: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (dashboardId != null) __params = __params.set('dashboardId', dashboardId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/MakeFavourite`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param dashboardId undefined
   */
  DashboardMakeFavourite(dashboardId?: number): __Observable<boolean> {
    return this.DashboardMakeFavouriteResponse(dashboardId).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param dashboardId undefined
   */
  DashboardRemoveFavouriteResponse(dashboardId?: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (dashboardId != null) __params = __params.set('dashboardId', dashboardId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/RemoveFavourite`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param dashboardId undefined
   */
  DashboardRemoveFavourite(dashboardId?: number): __Observable<boolean> {
    return this.DashboardRemoveFavouriteResponse(dashboardId).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `DashboardService.DashboardArchiveDashboardParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardArchiveDashboardResponse(params: DashboardService.DashboardArchiveDashboardParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/ArchiveDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardArchiveDashboardParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardArchiveDashboard(params: DashboardService.DashboardArchiveDashboardParams): __Observable<boolean> {
    return this.DashboardArchiveDashboardResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `DashboardService.DashboardUnArchiveDashboardParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnArchiveDashboardResponse(params: DashboardService.DashboardUnArchiveDashboardParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/UnArchiveDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardUnArchiveDashboardParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnArchiveDashboard(params: DashboardService.DashboardUnArchiveDashboardParams): __Observable<boolean> {
    return this.DashboardUnArchiveDashboardResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `DashboardService.DashboardPublishToPublicParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardPublishToPublicResponse(params: DashboardService.DashboardPublishToPublicParams): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/PublishToPublic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardPublishToPublicParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardPublishToPublic(params: DashboardService.DashboardPublishToPublicParams): __Observable<Dashboard> {
    return this.DashboardPublishToPublicResponse(params).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param params The `DashboardService.DashboardUnPublishToPublicParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnPublishToPublicResponse(params: DashboardService.DashboardUnPublishToPublicParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/UnPublishToPublic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardUnPublishToPublicParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnPublishToPublic(params: DashboardService.DashboardUnPublishToPublicParams): __Observable<boolean> {
    return this.DashboardUnPublishToPublicResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `DashboardService.DashboardPublishToGlobalParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardPublishToGlobalResponse(params: DashboardService.DashboardPublishToGlobalParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/PublishToGlobal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardPublishToGlobalParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardPublishToGlobal(params: DashboardService.DashboardPublishToGlobalParams): __Observable<boolean> {
    return this.DashboardPublishToGlobalResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `DashboardService.DashboardUnPublishToGlobalParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnPublishToGlobalResponse(params: DashboardService.DashboardUnPublishToGlobalParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/UnPublishToGlobal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardUnPublishToGlobalParams` containing the following parameters:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DashboardUnPublishToGlobal(params: DashboardService.DashboardUnPublishToGlobalParams): __Observable<boolean> {
    return this.DashboardUnPublishToGlobalResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param dashboard undefined
   */
  DashboardAddDashboardResponse(dashboard: Dashboard): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboard;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/AddDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param dashboard undefined
   */
  DashboardAddDashboard(dashboard: Dashboard): __Observable<Dashboard> {
    return this.DashboardAddDashboardResponse(dashboard).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param params The `DashboardService.DashboardAddCustomerDashboardParams` containing the following parameters:
   *
   * - `dashboard`:
   *
   * - `customerId`:
   */
  DashboardAddCustomerDashboardResponse(params: DashboardService.DashboardAddCustomerDashboardParams): __Observable<__StrictHttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.dashboard;
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Dashboard/AddCustomerDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dashboard>;
      })
    );
  }
  /**
   * @param params The `DashboardService.DashboardAddCustomerDashboardParams` containing the following parameters:
   *
   * - `dashboard`:
   *
   * - `customerId`:
   */
  DashboardAddCustomerDashboard(params: DashboardService.DashboardAddCustomerDashboardParams): __Observable<Dashboard> {
    return this.DashboardAddCustomerDashboardResponse(params).pipe(
      __map(_r => _r.body as Dashboard)
    );
  }

  /**
   * @param dashboard undefined
   */
  DashboardRemoveDashboardResponse(dashboard: Dashboard): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboard;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Dashboard/RemoveDashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dashboard undefined
   */
  DashboardRemoveDashboard(dashboard: Dashboard): __Observable<Blob> {
    return this.DashboardRemoveDashboardResponse(dashboard).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module DashboardService {

  /**
   * Parameters for DashboardGetAvailableWidgets
   */
  export interface DashboardGetAvailableWidgetsParams {
    tagValue: string;
    tagName: string;
    customerId: number;
  }

  /**
   * Parameters for DashboardGetAvailableWidgetsForSiteType
   */
  export interface DashboardGetAvailableWidgetsForSiteTypeParams {
    siteType: string;
    customerId: number;
  }

  /**
   * Parameters for DashboardArchiveDashboard
   */
  export interface DashboardArchiveDashboardParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardUnArchiveDashboard
   */
  export interface DashboardUnArchiveDashboardParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardPublishToPublic
   */
  export interface DashboardPublishToPublicParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardUnPublishToPublic
   */
  export interface DashboardUnPublishToPublicParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardPublishToGlobal
   */
  export interface DashboardPublishToGlobalParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardUnPublishToGlobal
   */
  export interface DashboardUnPublishToGlobalParams {
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardAddCustomerDashboard
   */
  export interface DashboardAddCustomerDashboardParams {
    dashboard: Dashboard;
    customerId?: number;
  }
}

export { DashboardService }
